import ownerLogComponent from './owner-log.component';

const ownerLogModule = angular.module('ownerLog', [
])
  .component('ownerLog', ownerLogComponent)
  .name;

export default ownerLogModule;
